import { render, staticRenderFns } from "./VRCheckbox.vue?vue&type=template&id=ca42cb9c"
import script from "./VRCheckbox.vue?vue&type=script&lang=js"
export * from "./VRCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports